import * as requestFromServer from "./customerCrud";
import { setErrorTypeAction } from "../errors/errorsActions";
import {setCustomers, setProviders, setSelectedCustomer, setInit} from "./customerSlice";
import { GetAllProducts } from "../products/productsActions";
import {GetCartAction} from "../cart/cartActions";
import routes from "../../app/routes/auth";
import {getProviders} from "./customerCrud";
import { actions as authActions } from "../../app/modules/Auth/_redux/authRedux";

export const GetCustomerAction = (t) => (dispatch) => {
	return requestFromServer
		.getCustomers()
		.then((response) => {
			const customers = response.customers
			dispatch(setCustomers(customers));
			const role = response.isBackoffice ? 'backoffice' : 'user';
			dispatch(authActions.setUserRole(role));
			if(role === 'backoffice'){
				routes().firstPage = '/richieste'
			}
			const idCustomer = localStorage.getItem('customerId');
			if(role !== 'backoffice' || idCustomer){
				const initCustomer = idCustomer && customers.find(ele => ele.id === idCustomer) ? customers.find(ele => ele.id === idCustomer) : customers[0];
				dispatch(setSelectedCustomer(initCustomer))
				dispatch(InitCustomerAction(t));
			}
			dispatch(setInit());
		})
		.catch((error) => {
			dispatch(setErrorTypeAction(t("sg.msg.errorLoadData")));
		});
};
export const InitCustomerAction = (t) => (dispatch, getState) => {
			dispatch(GetCartAction(t));
			dispatch(GetAllProducts(t));
};

export const setProvidersAction = () => (dispatch, getState) => {
	if(!getState().customer.providers.length){
		getProviders().then(res => {
			dispatch(setProviders(res));
		})
	}
};
